import { render, staticRenderFns } from "./attendance-detail.vue?vue&type=template&id=6084bad2"
import script from "./attendance-detail.vue?vue&type=script&lang=js"
export * from "./attendance-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports